import React from 'react';
import { formatMessageTime } from '~/utils/formatTime';
import { actions } from '../sagaSlice';
import { actions as practiceInboxActions } from '../../../../practice-inbox/sagaSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Linkify from 'react-linkify';
import punycode from 'punycode';

interface Props {
  message: Message;
}

function Message({ message }: Props) {
  const { message_content, send_date, deleted_at, read_at, sender, id, provider_id } = message;
  const { provider } = useSelector<State, MainState>((state) => state.main);
  const dispatch = useDispatch();
  const location = useLocation();
  const practiceInbox = location.pathname.includes('/practice-inbox');

  function handleDeleteMessage(id: string) {
    return () => {
      if (
        window.confirm('Are you sure you want to delete this message? This cannot be undone.') ===
        true
      ) {
        if (practiceInbox) {
          return dispatch(
            // @ts-ignore
            practiceInboxActions.deleteMessage({
              provider_id,
              message_id: id,
              account_id: provider?.account_id,
            })
          );
        }
        // @ts-ignore
        return dispatch(actions.deleteMessage({ provider_id, message_id: id }));
      }
    };
  }

  function renderMessageContent() {
    if (deleted_at) {
      // If deleted, render special message
      return 'You deleted this message.';
    } else {
      return message_content;
    }
  }

  const componentDecorator = (href: string, text: string, key: string) => (
    <a href={href} key={key} target='_blank' rel='noopener'>
      {punycode.toASCII(text)}
    </a>
  );

  return (
    <div className='message message_provider'>
      <div className='message-bubble message-bubble_provider'>
        <i>You set an automated reply</i>
        <hr className='w-100 m-y-xs' />
        {/* @ts-ignore */}
        <Linkify componentDecorator={componentDecorator}>
          <p className={`message-content ${deleted_at && 'deleted'}`}>{renderMessageContent()}</p>
        </Linkify>
        {!deleted_at && (
          <button type='button' onClick={handleDeleteMessage(id)} className='delete-message'>
            <i className='fas fa-trash'></i>
          </button>
        )}
      </div>
      <small className='message-date'>Sent {formatMessageTime(send_date)}</small>
    </div>
  );
}

export default Message;
